import PropTypes from "prop-types"
import { People } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function TeamResourcesHeader({ account, name }) {
  const teamName = name ? `Team Permissions: ${name}` : "Team Permissions"
  return <Header Icon={People} title={teamName} account={account} />
}

TeamResourcesHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.teamPermissions.data.team.name") }), null)(TeamResourcesHeader)
